import { useState } from "react";

function ActivationUtilisateur({ clientSupabase, token }) {
  const [password, setPassword] = useState("");
  const [confirmation, setConfirmation] = useState("");
  const [message, setMessage] = useState("");
  const [termine, setTermine] = useState(false);
  const [envoi, setEnvoi] = useState(false);
  const activer = async (event) => {
    event.preventDefault();
    if (password !== confirmation) { setMessage("Les mots de passe sont différents."); return; }
    if (password.length < 8) { setMessage("Le mot de passe doit contenir au moins 8 caractères."); return; }
    setEnvoi(true); setMessage("");
    const { data, error } = await clientSupabase.functions.invoke("activate-user", {
      body: { token, password }
    });
    setEnvoi(false);
    if (error) { setMessage("Lien invalide, expiré ou erreur technique."); return; }
    setTermine(true); setPassword(""); setConfirmation("");
    setMessage(data?.message || "Votre compte est activé.");
  };
  const input = { width: "100%", padding: 10, marginTop: 10, boxSizing: "border-box" };
  return <main style={{ minHeight: "100vh", background: "#f2f4f7", padding: 24, fontFamily: "Arial" }}><section style={{ maxWidth: 420, margin: "60px auto", background: "white", padding: 28, borderRadius: 10 }}>
    <h2>ACTIVER MON COMPTE</h2>
    {termine ? <><p>{message}</p><a href="/">REVENIR À LA CONNEXION</a></> : <form onSubmit={activer}>
      <p>Choisissez votre mot de passe. Aucun ancien mot de passe n'est nécessaire.</p>
      <input required type="password" placeholder="Nouveau mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} style={input}/>
      <input required type="password" placeholder="Confirmer le mot de passe" value={confirmation} onChange={(e) => setConfirmation(e.target.value)} style={input}/>
      {message && <p style={{ color: "#b71c1c" }}>{message}</p>}
      <button disabled={envoi} type="submit" style={{ ...input, background: "#1565c0", color: "white", border: 0 }}>{envoi ? "ACTIVATION..." : "ACTIVER MON COMPTE"}</button>
    </form>}
  </section></main>;
}

export default ActivationUtilisateur;
